import React from 'react';

import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalFooterProgressBar } from 'ui-components/components/modal/modal-footer/modal-footer-progress-bar';

import { useEditItemsContext } from '../context';
import SaveButton from './save-button';

const Footer = () => {
  const { isSaving } = useEditItemsContext();
  return (
    <>
      {isSaving && <ModalFooterProgressBar />}
      <ModalFooter>
        <ModalFooterCancelButton />
        <SaveButton />
      </ModalFooter>
    </>
  );
};

export default Footer;
